/** 항 코드 모양(`6`, `6-2`, `6-2-4`). 서버의 PUMSEM_CODE_PATTERN 과 같은 규칙이다. */
const CODE_LIKE = /^\d{1,3}(?:-\d{1,3}){0,3}$/;

export type PumsemSearchMode = 'name' | 'code';

/**
 * 검색어가 코드인지 이름인지.
 *
 * 실무자는 두 갈래로 들어온다 — 코드를 아는 사람(`6-2-4`)과 말을 아는 사람
 * (`PE-X 배관`). 한 입력창에 섞으면 둘 다 나빠지므로 모드를 가른다.
 * 사람이 고르기 전에 **입력값 모양으로 먼저 맞춰준다** — 대부분은 토글을
 * 건드리지 않는다(RSMeans 의 Line 검색 모드와 같은 갈래).
 */
export function detectSearchMode(query: string): PumsemSearchMode {
  return CODE_LIKE.test(query.trim()) ? 'code' : 'name';
}
